import styled from 'styled-components';
import { PageSpinner, Spinner } from '@landlord-tech/ui-kit-opp/dist/components/Spinner';
import { TSpinnerProps, UIKitTSpinnerProps } from './Spinner.type';

export const SSpinner = styled(Spinner)<TSpinnerProps>`
  &&& {
  }
`;
export const SPageSpinner = styled(PageSpinner)<UIKitTSpinnerProps>`
  &&& {
  }
`;
